import "./RoaStepComponent.scss";
import {AdviceTypes} from "../../models/AdviceTypes";
import {IFormController, IOnDestroy, IOnInit} from "angular";
import {AdviceType, isSameAdvice, OrderAdvice} from "../../models/OrderAdvice";
import {ReplaySubject} from "rxjs";
import {
    adviceAdviserChange,
    adviceBasisToggleChange,
    AdviceChange,
    adviceDeclarationToggleChange,
    adviceModelChange,
    adviceTypeChange,
    adviceTakerChange,
    advicePlacerChange,
    adviceReferenceChange,
    adviceMethodChange,
    adviceCapturedChange, adviceCommentChange
} from "./internal/AdviceChange";
import {applyChange} from "./internal/RoaStepComponentUtil";
import {isNotNull} from "../../../../../../js/util/UtilFunctions";

export const RoaStep = "roaStep";

export function roaStep() {
    return {
        templateUrl: "app/portfolio/templates/ticket/place-order-wizard/steps/roa/RoaStepComponent.html",
        bindings: {
            advice: "<",
            adviceTypes: "<",
            onChange: "&"
        },
        controllerAs: "ctrl",
        controller: RoaStepComponentController
    };
}

export class RoaStepComponentController implements IOnInit, IOnDestroy {

    /** @input */
    public set advice(advice: OrderAdvice | null) {
        if (advice != null) {
            const change = adviceModelChange(advice);
            this.changes$.next(change);
            this.checkValidAdviceBasis(advice);
            this.adviser = advice.adviser;
            this.orderTaker = advice.orderTaker;
            this.orderPlacer = advice.orderPlacer;
            this.reference = advice.reference;
            this.adviceMethod = advice.adviceMethod;
            this.adviceType = advice.adviceType;
            this.adviceCaptured = new Date(advice.adviceCaptured);
            this.declarations = advice.declarations;
            this.comment = advice.comment;
            this.adviceBasis = advice.adviceBasis;
        }
    }

    /** @input */
    public readonly adviceTypes: AdviceTypes;

    /** @output */
    public readonly onChange: Function;

    /** @ui-binding */
    public readonly roaForm: IFormController;

    /** ngModel bindings */
    public adviser: string | null;
    public orderTaker: string | null;
    public orderPlacer: string | null;
    public reference: string | null;
    public adviceMethod: string | null;
    public adviceType: AdviceType | null;
    public adviceCaptured: Date | null;
    public declarations: Array<string> = [];
    public comment: string | null;
    public adviceBasis: Array<string> = [];

    private readonly changes$ = new ReplaySubject<AdviceChange>(1);

    private readonly destroyed$ = new ReplaySubject<boolean>(1);

    public $onInit() {
        this.changes$
            .takeUntil(this.destroyed$)
            .scan((acc: OrderAdvice, next) => applyChange(acc, next), null as any as OrderAdvice)
            .filter(isNotNull)
            // .auditTime(100)
            .distinctUntilChanged(isSameAdvice)
            .subscribe((advice) => {
                console.log("Advice Changed");
                this.onChange({advice});
            });
    }

    public get orderPlacers(): ReadonlyArray<string> {
        if (this.adviceTypes == null) {
            return [];
        } else {
            return this.adviceTypes.placers;
        }
    }

    public adviserChanged(adviser: string) {
        const change = adviceAdviserChange(adviser);
        this.changes$.next(change);
    }

    public orderTakerChanged(orderTaker: string) {
        const change = adviceTakerChange(orderTaker);
        this.changes$.next(change);
    }

    public placerChanged(placer: string) {
        const change = advicePlacerChange(placer);
        this.changes$.next(change);
    }

    public referenceChanged(reference: string) {
        const change = adviceReferenceChange(reference);
        this.changes$.next(change);
    }

    public adviceMethodChanged(method: string) {
        const change = adviceMethodChange(method);
        this.changes$.next(change);
    }

    public toggleDeclaration(declaration: string) {
        const change = adviceDeclarationToggleChange(declaration);
        this.changes$.next(change);
    }

    public toggleBasis(basis: string) {
        const change = adviceBasisToggleChange(basis);
        this.changes$.next(change);
    }

    public adviceTypeChanged(type: AdviceType) {
        const change = adviceTypeChange(type);
        this.changes$.next(change);
    }

    public captureDateChanged(captured: Date) {
        const change = adviceCapturedChange(captured);
        this.changes$.next(change);
    }

    public commentChanged(comment: string) {
        const change = adviceCommentChange(comment);
        this.changes$.next(change);
    }

    private checkValidAdviceBasis(advice: OrderAdvice) {
        if (this.roaForm == null) {
            return;
        }
        if (advice.adviceType !== AdviceType.PERSONAL) {
            this.roaForm.$setValidity("advice", true, this.roaForm);
        } else {
            const hasBasis = advice.adviceBasis.length > 0;
            const hasAvailableBasis = this.adviceTypes.basis.length > 0;
            const isValid = hasBasis || !hasAvailableBasis;
            this.roaForm.$setValidity("advice", isValid, this.roaForm);
        }
    }

    public $onDestroy() {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }
}
